import React from 'react'
import Background from './bg.png'

const Landscape = () => {
    return (
        <>
            <img onContextMenu={(e)=>e.preventDefault()} draggable="false" alt='' src={Background} className='background-image' />
        </>
    )
}

export default Landscape